import apiClient from "./axios"

export const getAccountDashboard = async () => {
  const { data } = await apiClient.get("/account-reports/dashboard")
  return data
}

export const getAccountBalanceReport = async () => {
  const { data } = await apiClient.get("/account-reports/account-balance")
  return data
}

export const getCashFlow = async (params = {}) => {
  const { data } = await apiClient.get("/account-reports/cash-flow", { params })
  return data
}

export const getLoanSummary = async (params = {}) => {
  const { data } = await apiClient.get("/account-reports/loan-summary", { params })
  return data
}

export const getDailyReport = async (params = {}) => {
  const { data } = await apiClient.get("/account-reports/daily", { params })
  return data
}
